import {
    PUBLICA_LOGIN_URL,
    STG_ENVIRONMENT,
    PROD_HIDDEN_ENVIRONMENT,
    PROD_ENVIRONMENT,
    QA_ENVIRONMENT,
} from 'constants/index';
import { BASIC, VF, EH } from 'constants/creditCard/partners';
import { PRIVATE_URL, PRIVATE_HIRE_CREDIT_CARD } from 'constants/index';

export const buildLoginURLByEnv = () => {
    const urlmapped = {
        [STG_ENVIRONMENT]: `https://login.${STG_ENVIRONMENT}.openbank.es/`,
        [QA_ENVIRONMENT]: `https://login.${QA_ENVIRONMENT}.openbank.es/`,
        [PROD_HIDDEN_ENVIRONMENT]: `https://login.${PROD_HIDDEN_ENVIRONMENT}.openbank.es/`,
        [PROD_ENVIRONMENT]: PUBLICA_LOGIN_URL,
    };

    return urlmapped[__ENV__] || urlmapped[STG_ENVIRONMENT];
};

export const buildPartnerPrivateUrl = partnerId => {
    if (!partnerId) return `${PRIVATE_URL}${PRIVATE_HIRE_CREDIT_CARD}`;

    const partnersUrlMap = {
        [BASIC]: '/nrd-card',
        [VF]: '/vanity-fair',
        [EH]: '/eh-card',
    };
    return `${PRIVATE_URL}${PRIVATE_HIRE_CREDIT_CARD}${partnersUrlMap[partnerId]}`;
};
